export const syncEmailToOrganisation = (formValues, watchFn, setValue) => {
  if (formValues?.emailEducationalInstitution) {
    const currentFormData = watchFn();
    if ('otherOrganisation' in currentFormData) {
      setValue('otherOrganisation', formValues.emailEducationalInstitution);
    }
  }
};
